import type { Dispatch, SetStateAction } from "react";

export const EMPTY_ENROLLMENT_CATEGORY_SEARCH = "";

export const resetEnrollmentCategorySearch = (
  setSearchInputValue: Dispatch<SetStateAction<string>>,
  setSelectResetKey: Dispatch<SetStateAction<number>>,
): void => {
  setSearchInputValue(EMPTY_ENROLLMENT_CATEGORY_SEARCH);
  // Stryker disable next-line ArithmeticOperator -- either direction changes the
  // key and re-mounts SelectInput, which is the only required behavior.
  setSelectResetKey((key) => key + 1);
};
